import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type CreateKeyMappingApiResponse } from '../services/createKeyMapping'

export interface CreateKeyMappingState {
  isLoading: boolean
  error: string | undefined
  data: CreateKeyMappingApiResponse | undefined
  httpStatus: number | undefined
}

const initialState: CreateKeyMappingState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const createKeyMappingSlice = createSlice({
  name: 'createKeyMapping',
  initialState,
  reducers: {
    createKeyMappingLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    createKeyMappingUpdateAction: (state, action: PayloadAction<{ data: CreateKeyMappingApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    createKeyMappingErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    createKeyMappingResetAction: () => {
      return initialState
    }
  }
})

export const {
  createKeyMappingLoadingAction,
  createKeyMappingUpdateAction,
  createKeyMappingErrorAction,
  createKeyMappingResetAction
} = createKeyMappingSlice.actions

export default createKeyMappingSlice.reducer
